import { Typography } from '@mui/material';

const ModelRoot = () => (
  <Typography>
    Onboard’s data model provides standardized descriptions for your building’s physical, virtual,
    and logical assets, as well as their relationships to each other and the building. It transforms
    messy data into structured human and machine-readable information that is ready for your
    analysis. With Onboard, it’s easy to share or explore your data despite the multitude of
    equipment vintages, manufacturers, model numbers and geographical location of your buildings.
    The data model is based on Google’s open-source Digital Building Ontology, where Onboard is a
    leading contributor. The equipment and point types are enriched with tags from Project Haystack.
    You can further enrich the equipment and point types by adding your own custom labels on this
    page.
  </Typography>
);

export default ModelRoot;
